import Others from "../components/Others";

export default function OthersPage() {
  return (
    <section className="py-10">
      <Others />
    </section>
  );
}
